import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { observer } from 'mobx-react-lite';
import { useGlobalStore, useUserStore } from '/src/context';
import { toastMessages } from '/src/lib/toast';
import { SESSION_EXPIRED_REASON } from '/src/utils';

const Logout = observer(() => {
  const userStore = useUserStore();
  const globalStore = useGlobalStore();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const wasSessionExpired = (location.state as { reason?: string } | null)?.reason === SESSION_EXPIRED_REASON;
    if (!wasSessionExpired) globalStore.setPreviousPath('');
    userStore.logout();
    if (wasSessionExpired) {
      toast.error(toastMessages.sessionExpired.success);
    } else {
      toast.success(toastMessages.logout.success);
    }
    setIsLoading(false);
  }, []);

  return isLoading ? <></> : <Navigate to="/login" replace />;
});

export default Logout;
